<template>
  <div class="profile-name-popup survey-popup shop-popup">
    <div class="content">
      <img
        @click="$parent.isOpenSurvey = false"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <h5>Откуда узнали о мероприятии</h5>
      <div class="group-input">
        <small>Комментарий</small>
        <input
          type="text"
          placeholder="Комментарий"
          ref="comment"
          v-model="comment"
        />
      </div>
      <button @click.stop="setSurvey">Сохранить</button>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: {
    profile: Object,
  },
  data() {
    return {
      comment: "",
    };
  },
  created() {
    let that = this;
    setTimeout(function () {
      that.$refs["comment"].focus();
    }, 100);
  },
  mounted() {
    let that = this;
    document.addEventListener("keydown", function (evt) {
      if (evt.which === 27) {
        that.$parent.isOpenSurvey = false;
      }
    });
  },
  methods: {
    async setSurvey() {
      try {
        let payload = {
          comment: this.comment,
        };
        await api.profile.putRequest1111(this.profile.id, payload);
        this.$parent.isOpenSurvey = false;
        location.href = "/1111?request=1111-registration";
        this.$parent.isOpenThank = true;
      } catch (error) {
        console.log(error);
      }
      return false;
    },
  },
};
</script>
